// extracted by mini-css-extract-plugin
export default {"title":"footer_title__0Tkey","socials":"footer_socials__XEtQN","icon":"footer_icon__5YO8j","footer":"footer_footer__Q4qYo"};